module.exports = __webpack_public_path__ + "static/media/ag-staff4.cb87c150.jpg";